import { HasManyByField, OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import RecipientContact from '@/data/models/domain/RecipientContact'
import RecipientGroup from '@/data/models/domain/RecipientGroup'
import { TmArrayStringField } from '@/data/utils/types'
import RecipientFilteredView from '@/data/models/domain/RecipientFilteredView'

@OrmModel(modelNames.SCHEDULED_CAMPAIGN_RECIPIENTS)
export default class ScheduledEmailRecipients extends BaseModel {
  @TmArrayStringField()
  public contactIds: string[]

  @HasManyByField(RecipientContact, 'contactIds')
  public contacts: RecipientContact[]

  @TmArrayStringField()
  public groupIds: string[]

  @HasManyByField(RecipientGroup, 'groupIds')
  public groups: RecipientGroup[]

  @TmArrayStringField()
  public emailAddresses: string[]

  @TmArrayStringField()
  public filteredViewsIds: string[]

  @HasManyByField(RecipientFilteredView, 'filteredViewsIds')
  public filteredViews: RecipientFilteredView[]
}
